import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import ManagerDashboardStore from 'stores/ManagerDashboardStore';
import classNames from 'classnames';
import './DashboardV2LoadingOverlay.styl';
import ManagerDashboardActions from 'actions/ManagerDashboardActions';
import {CoachLogo} from '@components/logo/CoachLogo';

@connectToStores
export default class DashboardV2LoadingOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {timestamp: null};
  }

  static getStores() {
    return [ManagerDashboardStore];
  }

  static getPropsFromStores() {
    const {hasRenderedDashv2Gif} = ManagerDashboardStore.getState();
    return {hasRenderedDashv2Gif};
  }

  componentDidMount() {
    this.setState({timestamp: Date.now().valueOf()}, () => {
      this.gifHasFinishedTimer = setTimeout(() => {
        ManagerDashboardActions.hasRenderedDashv2Gif.defer();
      }, 3000);
    });
  }

  componentWillUnmount() {
    clearTimeout(this.gifHasFinishedTimer);
  }

  render() {
    const {hasRenderedDashv2Gif} = this.props;

    const hidden = hasRenderedDashv2Gif;
    return (
      <div className={classNames('page-loading-wrapper--full-height', {hidden})}>
        <div className={classNames('page-loading-wrapper', {hidden})}>
          <Coach360Overlay />
        </div>
      </div>
    );
  }
}

function Coach360Overlay() {
  return (
    <div className="coach360-overlay">
      <CoachLogo includeBrandName={false} />
    </div>
  );
}
